import { render, staticRenderFns } from "./Hzzx.vue?vue&type=template&id=1bf0d69c&scoped=true&"
import script from "./Hzzx.vue?vue&type=script&lang=js&"
export * from "./Hzzx.vue?vue&type=script&lang=js&"
import style0 from "./Hzzx.vue?vue&type=style&index=0&id=1bf0d69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0d69c",
  null
  
)

export default component.exports